import { FC, PropsWithChildren, useEffect, useState } from "react";

export type TransitionFadeInProps = {
    durationSecs?: number;
};

export const TransitionFadeIn: FC<PropsWithChildren<TransitionFadeInProps>> = ({
    durationSecs = 0.6,
    children
}) =>
{    
    const [show,setShow] = useState(false)
    useEffect(() => 
    {
        setShow(true);
    },[]);

    return (
        <>
            <div className={"container"+(show?" show":"")} style={{
                transition: `visibility ${durationSecs}s,opacity ${durationSecs}s`
            }}>{children}</div>
            <style jsx>{`
            .container {
                visibility: hidden;
                opacity: 0;
            }

            .container.show {
                visibility: visible;
                opacity: 1;
            }
            `}</style>
        </>
    );
}